export var NativeStreamWeightMode;
(function (NativeStreamWeightMode) {
    NativeStreamWeightMode["NATIVE_STREAM_WEIGHT_MODE_UNSPECIFIED"] = "NATIVE_STREAM_WEIGHT_MODE_UNSPECIFIED";
    NativeStreamWeightMode["NATIVE_STREAM_WEIGHT_MODE_IPW"] = "IPW";
    NativeStreamWeightMode["NATIVE_STREAM_WEIGHT_MODE_EXACT"] = "EXACT";
})(NativeStreamWeightMode || (NativeStreamWeightMode = {}));
